module.exports = __webpack_public_path__ + "static/media/VGN Builders-Ice Cream.47e7e4ee.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/VGN Builders-Ice Cream.gif
// module id = 383
// module chunks = 0